import React, { useState, useEffect } from "react";
import { FaArrowRight, FaTimes } from "react-icons/fa";
import { axiosInstance } from "../Api/config";

const fallbackBikes = [
  "Bullet 350",
  "Hunter 350",
  "Meteor 350",
  "Super Meteor 450",
  "Continental GT 650",
  "Interceptor 650",
  "Scram 411",
  "Himalayan",
  "Not Sure Yet",
];

const TestRideModal = ({ isOpen, onClose, onSubmit }) => {
  const [bikeModels, setBikeModels] = useState(fallbackBikes);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    bikeModel: "",
    preferredDate: "",
    preferredTime: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const fetchBikes = async () => {
      try {
        const res = await axiosInstance.get("/bike-models/active");
        if (res.data && res.data.length > 0) {
          const names = res.data.map(b => b.name);
          setBikeModels([...names, "Not Sure Yet"]);
        }
      } catch (err) {
        console.error("Error fetching models for TestRideModal:", err);
      }
    };
    fetchBikes();
  }, [isOpen]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.name || !formData.phone || !formData.bikeModel) {
      alert("Please fill in all required fields");
      return;
    }

    // Call parent handler
    if (onSubmit) {
      onSubmit(formData);
    }

    setSubmitted(true);
    setTimeout(() => {
      setFormData({
        name: "",
        phone: "",
        email: "",
        bikeModel: "",
        preferredDate: "",
        preferredTime: "",
        message: "",
      });
      setSubmitted(false);
      onClose();
    }, 2000);
  };

  if (!isOpen) return null;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=DM+Sans:wght@400;500;600&family=Barlow+Condensed:wght@400;600;700;800&display=swap');

        .font-bebas { font-family: 'Oswald', sans-serif; letter-spacing: 0.02em; }
        .font-barlow { font-family: 'DM Sans', sans-serif; }
        .font-barlow-cond { font-family: 'Barlow Condensed', sans-serif; }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999;
          padding: 16px;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .modal-content {
          background: #111111;
          border: 1px solid rgba(212, 175, 55, 0.2);
          border-radius: 12px;
          width: 100%;
          max-width: 600px;
          padding: 40px;
          position: relative;
          z-index: 1000;
          animation: slideUp 0.4s ease;
          max-height: 90vh;
          overflow-y: auto;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
          border-bottom: 2px solid #D4AF37;
          padding-bottom: 16px;
        }

        .modal-title {
          font-family: 'Oswald', sans-serif;
          font-size: 32px;
          color: #F5F5F5;
          letter-spacing: 0.05em;
        }

        .close-btn {
          background: none;
          border: none;
          font-size: 24px;
          color: #D4AF37;
          cursor: pointer;
          transition: color 0.3s;
          padding: 0;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .close-btn:hover {
          color: #F5D76E;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-label {
          display: block;
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 11px;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: #D4AF37;
          margin-bottom: 8px;
          font-weight: 600;
        }

        .form-label .required {
          color: #F5D76E;
        }

        .form-input,
        .form-select,
        .form-textarea {
          width: 100%;
          background: #0d0d0d;
          border: 1px solid rgba(212, 175, 55, 0.2);
          color: #F5F5F5;
          padding: 12px 16px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          border-radius: 4px;
          outline: none;
          transition: border-color 0.3s, box-shadow 0.3s;
          box-sizing: border-box;
        }

        .form-input::placeholder,
        .form-select::placeholder,
        .form-textarea::placeholder {
          color: #555;
        }

        .form-input:focus,
        .form-select:focus,
        .form-textarea:focus {
          border-color: #D4AF37;
          box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.1);
        }

        .form-select option {
          background: #111111;
          color: #F5F5F5;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }

        .form-textarea {
          resize: vertical;
          min-height: 100px;
          font-family: 'DM Sans', sans-serif;
        }

        .submit-btn {
          width: 100%;
          background: #D4AF37;
          color: #000;
          border: none;
          padding: 14px 24px;
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 13px;
          font-weight: bold;
          letter-spacing: 2px;
          text-transform: uppercase;
          cursor: pointer;
          transition: background 0.3s, transform 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          border-radius: 4px;
          margin-top: 24px;
        }

        .submit-btn:hover:not(:disabled) {
          background: #F5D76E;
          transform: translateY(-2px);
        }

        .submit-btn:active:not(:disabled) {
          transform: translateY(0);
        }

        .submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .success-message {
          background: rgba(212, 175, 55, 0.1);
          border: 1px solid #D4AF37;
          color: #D4AF37;
          padding: 16px;
          border-radius: 4px;
          margin-bottom: 16px;
          text-align: center;
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 13px;
          letter-spacing: 2px;
          text-transform: uppercase;
        }

        @media (max-width: 640px) {
          .modal-content {
            padding: 24px;
            margin: 16px;
          }

          .modal-title {
            font-size: 24px;
          }

          .form-row {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2 className="modal-title">Book Test Ride</h2>
            <button className="close-btn" onClick={onClose}>
              <FaTimes />
            </button>
          </div>

          {submitted ? (
            <div className="success-message">
              ✓ Thank you! We'll contact you soon to confirm your test ride.
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">
                    Your Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Ravi Kumar"
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">
                    Phone Number <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 98765 43210"
                    className="form-input"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="ravi@example.com"
                  className="form-input"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">
                    Interested Bike Model <span className="required">*</span>
                  </label>
                  <select
                    name="bikeModel"
                    value={formData.bikeModel}
                    onChange={handleChange}
                    className="form-select"
                    required
                  >
                    <option value="">Select a model</option>
                    {bikeModels.map((model) => (
                      <option key={model} value={model}>
                        {model}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">Preferred Date</label>
                  <input
                    type="date"
                    name="preferredDate"
                    value={formData.preferredDate}
                    onChange={handleChange}
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Preferred Time</label>
                <input
                  type="time"
                  name="preferredTime"
                  value={formData.preferredTime}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Additional Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us anything you'd like us to know..."
                  className="form-textarea"
                />
              </div>

              <button type="submit" className="submit-btn">
                Book Test Ride
                <FaArrowRight />
              </button>
            </form>
          )}
        </div>
      </div>
    </>
  );
};

export default TestRideModal;
